import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Button } from '../components/ui/button';
import { Shield, Lock } from 'lucide-react';
import { useToast } from '../hooks/use-toast';

const AdminLoginPage = ({ onLogin }) => {
  const { toast } = useToast();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  // Default admin credentials (you can change these)
  const ADMIN_USERNAME = 'admin';
  const ADMIN_PASSWORD = 'CruiseAdmin2025!';

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);

    // Simulate a small delay for security
    setTimeout(() => {
      if (username === ADMIN_USERNAME && password === ADMIN_PASSWORD) {
        toast({
          title: "Login Successful",
          description: "Welcome to the admin dashboard!",
        });
        onLogin(true);
      } else {
        toast({
          title: "Login Failed",
          description: "Invalid username or password.",
          variant: "destructive"
        });
        setPassword('');
      }
      setIsLoading(false);
    }, 500);
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ background: 'linear-gradient(to bottom, #0f5a7d, #0a3d54)' }}>
      <Card className="w-full max-w-md border-none shadow-2xl">
        <CardHeader className="text-center pb-4">
          <div className="w-20 h-20 mx-auto mb-4 rounded-full bg-teal-100 flex items-center justify-center">
            <Shield className="w-10 h-10 text-teal-600" />
          </div>
          <CardTitle className="text-3xl font-bold text-gray-800">
            Admin Login
          </CardTitle>
          <p className="text-gray-600 mt-2">Cruise Ship Parking Management</p>
        </CardHeader>
        <CardContent className="px-8 pb-8">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <Label htmlFor="username" className="text-gray-700 font-semibold">
                Username
              </Label>
              <Input
                id="username"
                type="text"
                placeholder="Enter username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="mt-2"
                required
                autoComplete="username"
              />
            </div>
            
            <div>
              <Label htmlFor="password" className="text-gray-700 font-semibold">
                Password
              </Label>
              <Input
                id="password"
                type="password"
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-2"
                required
                autoComplete="current-password"
              />
            </div>

            <Button
              type="submit"
              disabled={isLoading}
              className="w-full bg-teal-600 hover:bg-teal-700 text-white py-6 text-lg font-semibold"
            >
              <Lock className="mr-2" size={20} />
              {isLoading ? 'Logging in...' : 'Login to Dashboard'}
            </Button>
          </form>

          <div className="mt-6 p-4 bg-blue-50 rounded-lg border border-blue-200">
            <p className="text-xs text-gray-600 text-center mb-3">
              <strong>Admin Login Credentials:</strong><br/>
              Username: admin<br/>
              Password: CruiseAdmin2025!
            </p>
            <p className="text-xs text-blue-600 text-center font-semibold">
              Admin URL: /CruiseAdmin
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminLoginPage;
